const PATH = {
  INDEX: '/',
  TERMS_OF_SERVICE: '/terms-of-service',
  PRIVACY_POLICY: '/privacy-policy',
  DASHBOARD: {
    INDEX: '/app',
    NEW: '/app/new',
    REPORT: (id: string) => `/app/report/${id}`,
    FINANCIAL: '/app/financial',
  },
  NOT_FOUND: '*',
};

export default PATH;
